import { render, staticRenderFns } from "./NewWidgetGetSponsorLicenceDialog.vue?vue&type=template&id=e3fe31c6&scoped=true&lang=pug"
import script from "./NewWidgetGetSponsorLicenceDialog.vue?vue&type=script&lang=ts"
export * from "./NewWidgetGetSponsorLicenceDialog.vue?vue&type=script&lang=ts"
import style0 from "./NewWidgetGetSponsorLicenceDialog.vue?vue&type=style&index=0&id=e3fe31c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fe31c6",
  null
  
)

/* custom blocks */
import block0 from "./NewWidgetGetSponsorLicenceDialog.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FV2%2FWidgetGetSponsorLicence%2FNewWidgetGetSponsorLicenceDialog.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports